import React from 'react';
import { Link } from 'react-router-dom';
import { Button } from './button';
import { ActivationCodes } from './activation-codes';

export function AccessCodesPage() {
  return (
    <div className="flex flex-col min-h-screen bg-background">
      {/* Header */}
      <header className="w-full z-50 fixed top-0 left-0 px-4 py-3">
        <div className="mx-auto max-w-7xl">
          <div className="flex items-center justify-between w-full h-14 rounded-xl bg-background/80 backdrop-blur-lg border border-border/60 shadow-sm px-6 transition-all duration-300">
            <div className="flex items-center">
              <div className="font-bold text-xl font-serif">CAUDE</div>
            </div>
            <div className="flex items-center space-x-3">
              <Button 
                variant="ghost" 
                size="sm" 
                asChild
              >
                <Link to="/">Home</Link>
              </Button>
              <Button 
                variant="ghost" 
                size="sm" 
                asChild
              >
                <Link to="/profile">Profile</Link>
              </Button>
            </div>
          </div>
        </div>
      </header>

      {/* Scrollable Content Area */}
      <div className="flex-1 overflow-y-auto pt-20 pb-12 px-4">
        <div className="max-w-4xl mx-auto">
          <div className="text-center mb-12">
            <h1 className="text-3xl md:text-4xl font-bold text-foreground mb-4">Access Codes</h1>
            <p className="text-lg text-muted-foreground">Manage your desktop application access codes</p>
          </div>

          {/* Desktop Activation Codes */}
          <div className="mb-8">
            <ActivationCodes />
          </div>

          <div className="text-center">
            <Button variant="outline" asChild>
              <Link to="/profile">Back to Profile</Link>
            </Button>
          </div>
        </div>
      </div>
    </div>
  );
}

export default AccessCodesPage;